import React, { useEffect, useState } from "react";

import { TableRow, TableCell } from "@material-ui/core";

import { stableSort, getComparator } from "App/Component/ui/datatable/utils";

import {
  // ModalDeleteConfirm,
  TableCellDefault,
  TableWrapper,
  TableAction,
  Loading,
} from "App/Component/ui";

import { STYLE_DEFAULT_MASTER } from "App/constants/theme";

// import { useFetch, useDatatables } from "App/hooks";
import {
  // getAllHospital,
  // ModalForm,
  // headCells,
  RESET_STATE_RUMAH_SAKIT,
  getAllHospital,
} from "./helpers";
// import { TYPE_INSTANCE1 } from "App/constants";
import { defaultToastError } from "App/utils/helpers";
import FormHospital from "./FormHospital";
import Title from "App/Component/ui/title/Title";
// import { FilterColumns, PrepareDataExport } from "../helpers";

export default function Hospital() {
  const classes = STYLE_DEFAULT_MASTER();

  // const [showModal, setShowModal] = useState(false);
  // const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);

  // const [rows, setRows] = useFetch(TYPE_INSTANCE1, "/hospital/listhospital");

  const [loading, setLoading] = useState(false);
  const [photo, setPhoto] = useState(null);
  const [formData, setFormData] = useState(RESET_STATE_RUMAH_SAKIT);

  useEffect(() => {
    (async () => {
      await fetchDataForm();
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchDataForm = async () => {
    setLoading(true);
    const res = await getAllHospital();
    if (res.state) {
      const data = res.data;
      setFormData({
        id: data?.id,
        name: data?.name,
        code: data?.code,
        postal_code: data?.postal_code,
        address: data?.address,
        type: data?.type,
        fax: data?.fax,
        city: data?.city,
        no_tlpn: data?.no_tlpn,
        width: data?.width,
        height: data?.height,
        period_booking: data?.period_booking,
        is_filter: data?.is_filter,
        num_code: data?.num_code,
        regis_date: data?.regis_date,
        class: data?.class,
        directors_name: data?.directors_name,
        organizers_name: data?.organizers_name,
        email: data?.email,
        no_tlpn_w_ext: data?.no_tlpn_w_ext,
        website: data?.website,
        land_area: data?.land_area,
        building_area: data?.building_area,
        licensing_num: data?.licensing_num,
        licensing_date: data?.licensing_date,
        licensing_issued_by: data?.licensing_issued_by,
        status_penyelenggara_swasta: data?.status_penyelenggara_swasta,
        akreditasi_pentahapan: data?.akreditasi_pentahapan,
        akreditasi_status: data?.akreditasi_status,
        akreditasi_date: data?.akreditasi_date,
      });
      setPhoto(data?.image);
    } else {
      defaultToastError(res.message);
    }
    setLoading(false);
  };

  return (
    <div className={classes.root}>
    <Title title="Master Rumah Sakit"/>
    <Loading show={loading}/>
     <FormHospital
      formData={formData}
      photo={photo}
      setFormData={setFormData}
      setPhoto={setPhoto}
      fetchDataForm={fetchDataForm}
     />
    </div>
  );
}
